(() => {
  const SOCIAL_SESSION_KEY = 'tfc-inner-dialog-social-traffic';
  const TRAFFIC_SOURCE_SESSION_KEY = 'tfc-inner-dialog-traffic-source';
  const COUNTRY_SESSION_KEY = 'tfc-inner-dialog-country';
  const COUNTRY_CACHE_TTL = 60 * 60 * 1000;
  const DEFAULT_ELIGIBLE_COUNTRIES = ['DE', 'AT', 'CH', 'NL'];
  const DEFAULT_BLOCKED_TRAFFIC_SOURCES = [
    'Paid Social',
    'Organic Social',
    'Paid Video',
    'Organic Video',
    'Display',
    'Paid Other',
    'Organic Shopping',
    'SMS',
  ];
  const DEFAULT_EXCLUDED_PATH_PREFIXES = ['/en', '/blogs/', '/pages/', '/account/login', '/account/register'];
  const IRRELEVANT_DIRECT_PARAMS = new Set([
    'variant',
    'igTg',
    'page',
    'shpxid',
    'shop',
    'view',
    'siteid',
    'token',
    'cart',
    'order',
    'from',
    'search',
    'pb',
    'preview_theme_id',
    'igId',
    'cb',
  ]);
  const SEARCH_SITES = new Set(
    '360.cn,alice,aol,ar.search.yahoo.com,ask,at.search.yahoo.com,au.search.yahoo.com,auone,avg,babylon,baidu,biglobe,biglobe.co.jp,biglobe.ne.jp,bing,br.search.yahoo.com,ca.search.yahoo.com,centrum.cz,ch.search.yahoo.com,cl.search.yahoo.com,cn.bing.com,bing.com,cnn,co.search.yahoo.com,comcast,conduit,daum,daum.net,de.search.yahoo.com,dk.search.yahoo.com,dogpile,dogpile.com,duckduckgo,ecosia.org,email.seznam.cz,eniro,es.search.yahoo.com,espanol.search.yahoo.com,exalead.com,excite.com,fi.search.yahoo.com,firmy.cz,fr.search.yahoo.com,globo,go.mail.ru,google,google.com,google-play,hk.search.yahoo.com,id.search.yahoo.com,in.search.yahoo.com,incredimail,it.search.yahoo.com,kvasir,lens.google.com,lite.qwant.com,lycos,m.baidu.com,m.naver.com,m.search.naver.com,m.sogou.com,mail.rambler.ru,mail.yandex.ru,malaysia.search.yahoo.com,msn,msn.com,mx.search.yahoo.com,najdi,naver,naver.com,news.google.com,nl.search.yahoo.com,no.search.yahoo.com,ntp.msn.com,nz.search.yahoo.com,onet,onet.pl,pe.search.yahoo.com,ph.search.yahoo.com,pl.search.yahoo.com,play.google.com,qwant,qwant.com,rakuten,rakuten.co.jp,rambler,rambler.ru,se.search.yahoo.com,search-results,search.aol.co.uk,search.aol.com,search.google.com,search.smt.docomo.ne.jp,search.ukr.net,secureurl.ukr.net,seznam,seznam.cz,sg.search.yahoo.com,so.com,sogou,sogou.com,sp-web.search.auone.jp,startsiden,startsiden.no,suche.aol.de,terra,th.search.yahoo.com,tr.search.yahoo.com,tut.by,tw.search.yahoo.com,uk.search.yahoo.com,ukr,us.search.yahoo.com,virgilio,vn.search.yahoo.com,wap.sogou.com,webmaster.yandex.ru,websearch.rakuten.co.jp,yahoo,yahoo.co.jp,yahoo.com,yandex,yandex.by,yandex.com,yandex.com.tr,yandex.fr,yandex.kz,yandex.ru,yandex.ua,yandex.uz,zen.yandex.ru'.split(','),
  );
  const SHOPPING_SITES = new Set(
    'Google Shopping,IGShopping,aax-us-east.amazon-adsystem.com,aax.amazon-adsystem.com,alibaba,alibaba.com,amazon,amazon.co.uk,amazon.com,apps.shopify.com,checkout.shopify.com,checkout.stripe.com,cr.shopping.naver.com,cr2.shopping.naver.com,ebay,ebay.co.uk,ebay.com,ebay.com.au,ebay.de,etsy,etsy.com,m.alibaba.com,m.shopping.naver.com,mercadolibre,mercadolibre.com,mercadolibre.com.ar,mercadolibre.com.mx,message.alibaba.com,msearch.shopping.naver.com,nl.shopping.net,no.shopping.net,offer.alibaba.com,one.walmart.com,order.shopping.yahoo.co.jp,partners.shopify.com,s3.amazonaws.com,se.shopping.net,shop.app,shopify,shopify.com,shopping.naver.com,shopping.yahoo.co.jp,shopping.yahoo.com,shopzilla,shopzilla.com,simplycodes.com,store.shopping.yahoo.co.jp,stripe,stripe.com,uk.shopping.net,walmart,walmart.com'.split(','),
  );
  const APP_SOCIAL_SITES = new Set(
    '43things,43things.com,51.com,5ch.net,Hatena,ImageShack,academia.edu,activerain,activerain.com,activeworlds,activeworlds.com,addthis,addthis.com,airg.ca,allnurses.com,allrecipes.com,alumniclass,alumniclass.com,ameba.jp,ameblo.jp,americantowns,americantowns.com,amp.reddit.com,ancestry.com,anobii,anobii.com,answerbag,answerbag.com,answers.yahoo.com,aolanswers,aolanswers.com,apps.facebook.com,ar.pinterest.com,artstation.com,askubuntu,askubuntu.com,asmallworld.com,athlinks,athlinks.com,away.vk.com,awe.sm,b.hatena.ne.jp,baby-gaga,baby-gaga.com,babyblog.ru,badoo,badoo.com,bebo,bebo.com,beforeitsnews,beforeitsnews.com,bharatstudent,bharatstudent.com,biip.no,biswap.org,bit.ly,blackcareernetwork.com,blackplanet,blackplanet.com,blip.fm,blog.com,blog.feedspot.com,blog.goo.ne.jp,blog.naver.com,blog.yahoo.co.jp,blogg.no,bloggang.com,blogger,blogger.com,blogher,blogher.com,bloglines,bloglines.com,blogs.com,blogsome,blogsome.com,blogspot,blogspot.com,blogster,blogster.com,blurtit,blurtit.com,bookmarks.yahoo.co.jp,bookmarks.yahoo.com,br.pinterest.com,brightkite,brightkite.com,brizzly,brizzly.com,business.facebook.com,buzzfeed,buzzfeed.com,buzznet,buzznet.com,cafe.naver.com,cafemom,cafemom.com,camospace,camospace.com,canalblog.com,care.com,care2,care2.com,caringbridge.org,catster,catster.com,cbnt.io,cellufun,cellufun.com,centerblog.net,chat.zalo.me,chegg.com,chicagonow,chicagonow.com,chiebukuro.yahoo.co.jp,classmates,classmates.com,classquest,classquest.com,co.pinterest.com,cocolog-nifty,cocolog-nifty.com,copainsdavant.linternaute.com,couchsurfing.org,cozycot,cozycot.com,cross.tv,crunchyroll,crunchyroll.com,cyworld,cyworld.com,cz.pinterest.com,d.hatena.ne.jp,dailystrength.org,deluxe.com,deviantart,deviantart.com,dianping,dianping.com,digg,digg.com,diigo,diigo.com,discover.hubpages.com,disqus,disqus.com,dogster,dogster.com,dol2day,dol2day.com,doostang,doostang.com,dopplr,dopplr.com,douban,douban.com,draft.blogger.com,draugiem.lv,drugs-forum,drugs-forum.com,dzone,dzone.com,edublogs.org,elftown,elftown.com,epicurious.com,everforo.com,exblog.jp,extole,extole.com,facebook,facebook.com,faceparty,faceparty.com,fandom.com,fanpop,fanpop.com,fark,fark.com,fb,fb.me,fc2,fc2.com,feedspot,feministing,feministing.com,filmaffinity,filmaffinity.com,flickr,flickr.com,flipboard,flipboard.com,folkdirect,folkdirect.com,foodservice,foodservice.com,forums.androidcentral.com,forums.crackberry.com,forums.imore.com,forums.nexopia.com,forums.webosnation.com,forums.wpcentral.com,fotki,fotki.com,fotolog,fotolog.com,foursquare,foursquare.com,free.facebook.com,friendfeed,friendfeed.com,fruehstueckstreff.org,fubar,fubar.com,gaiaonline,gaiaonline.com,gamerdna,gamerdna.com,gather.com,geni.com,getpocket.com,glassboard,glassboard.com,glassdoor,glassdoor.com,godtube,godtube.com,goldenline.pl,goldstar,goldstar.com,goo.gl,gooblog,goodreads,goodreads.com,google+,googlegroups.com,googleplus,govloop,govloop.com,gowalla,gowalla.com,gree.jp,groups.google.com,gulli.com,gutefrage.net,habbo,habbo.com,hi5,hi5.com,hootsuite,hootsuite.com,houzz,houzz.com,hoverspot,hoverspot.com,hr.com,hu.pinterest.com,hubculture,hubculture.com,hubpages.com,hyves.net,hyves.nl,ibibo,ibibo.com,id.pinterest.com,identi.ca,ig,imageshack.com,imageshack.us,imvu,imvu.com,in.pinterest.com,insanejournal,insanejournal.com,instagram,instagram.com,instapaper,instapaper.com,internations.org,interpals.net,intherooms,intherooms.com,irc-galleria.net,is.gd,italki,italki.com,jammerdirect,jammerdirect.com,jappy.com,jappy.de,kaboodle.com,kakao,kakao.com,kakaocorp.com,kaneva,kaneva.com,kin.naver.com,l.facebook.com,l.instagram.com,l.messenger.com,last.fm,librarything,librarything.com,lifestream.aol.com,line,line.me,linkedin,linkedin.com,listal,listal.com,listography,listography.com,livedoor.com,livedoorblog,livejournal,livejournal.com,lm.facebook.com,lnkd.in,m.blog.naver.com,m.cafe.naver.com,m.facebook.com,m.kin.naver.com,m.vk.com,m.yelp.com,mbga.jp,medium.com,meetin.org,meetup,meetup.com,meinvz.net,meneame.net,menuism.com,messages.google.com,messages.yahoo.co.jp,messenger,messenger.com,mix.com,mixi.jp,mobile.facebook.com,mocospace,mocospace.com,mouthshut,mouthshut.com,movabletype,movabletype.com,mubi,mubi.com,my.opera.com,myanimelist.net,myheritage,myheritage.com,mylife,mylife.com,mymodernmet,mymodernmet.com,myspace,myspace.com,netvibes,netvibes.com,news.ycombinator.com,newsshowcase,nexopia,ngopost.org,niconico,nicovideo.jp,nightlifelink,nightlifelink.com,ning,ning.com,nl.pinterest.com,odnoklassniki.ru,odnoklassniki.ua,okwave.jp,old.reddit.com,oneworldgroup.org,onstartups,onstartups.com,opendiary,opendiary.com,oshiete.goo.ne.jp,out.reddit.com,over-blog.com,overblog.com,paper.li,partyflock.nl,photobucket,photobucket.com,pinboard,pinboard.in,pingsta,pingsta.com,pinterest,pinterest.at,pinterest.ca,pinterest.ch,pinterest.cl,pinterest.co.kr,pinterest.co.uk,pinterest.com,pinterest.com.au,pinterest.com.mx,pinterest.de,pinterest.es,pinterest.fr,pinterest.it,pinterest.jp,pinterest.nz,pinterest.ph,pinterest.pt,pinterest.ru,pinterest.se,pixiv.net,pl.pinterest.com,playahead.se,plurk,plurk.com,plus.google.com,plus.url.google.com,pocket.co,posterous,posterous.com,pro.homeadvisor.com,pulse.yahoo.com,qapacity,qapacity.com,quechup,quechup.com,quora,quora.com,qzone.qq.com,ravelry,ravelry.com,reddit,reddit.com,redux,redux.com,renren,renren.com,researchgate.net,reunion,reunion.com,reverbnation,reverbnation.com,rtl.de,ryze,ryze.com,salespider,salespider.com,scoop.it,screenrant,screenrant.com,scribd,scribd.com,scvngr,scvngr.com,secondlife,secondlife.com,serverfault,serverfault.com,shareit,sharethis,sharethis.com,shvoong.com,sites.google.com,skype,skyrock,skyrock.com,slashdot.org,slideshare.net,smartnews.com,snapchat,snapchat.com,social,sociallife.com.br,socialvibe,socialvibe.com,spaces.live.com,spoke,spoke.com,spruz,spruz.com,ssense.com,stackapps,stackapps.com,stackexchange,stackexchange.com,stackoverflow,stackoverflow.com,stardoll.com,stickam,stickam.com,studivz.net,suomi24.fi,superuser,superuser.com,sweeva,sweeva.com,t.co,t.me,tagged,tagged.com,taggedmail,taggedmail.com,talkbiznow,talkbiznow.com,taringa.net,techmeme,techmeme.com,tencent,tencent.com,tiktok,tiktok.com,tinyurl,tinyurl.com,toolbox,toolbox.com,touch.facebook.com,tr.pinterest.com,travellerspoint,travellerspoint.com,tripadvisor,tripadvisor.com,trombi,trombi.com,trustpilot,tudou,tudou.com,tuenti,tuenti.com,tumblr,tumblr.com,tweetdeck,tweetdeck.com,twitter,twitter.com,twoo.com,typepad,typepad.com,unblog.fr,urbanspoon.com,ushareit.com,ushi.cn,vampirefreaks,vampirefreaks.com,vampirerave,vampirerave.com,vg.no,video.ibm.com,vk.com,vkontakte.ru,wakoopa,wakoopa.com,wattpad,wattpad.com,web.facebook.com,web.skype.com,webshots,webshots.com,wechat,wechat.com,weebly,weebly.com,weibo,weibo.com,wer-weiss-was.de,weread,weread.com,whatsapp,whatsapp.com,wiki.answers.com,wikihow.com,wikitravel.org,woot.com,wordpress,wordpress.com,wordpress.org,xanga,xanga.com,xing,xing.com,yahoo-mbga.jp,yammer,yammer.com,yelp,yelp.co.uk,yelp.com,youroom.in,za.pinterest.com,zalo,zoo.gr,zooppa,zooppa.com'.split(','),
  );
  const VIDEO_SITES = new Set(
    'blog.twitch.tv,crackle,crackle.com,curiositystream,curiositystream.com,d.tube,dailymotion,dailymotion.com,dashboard.twitch.tv,disneyplus,disneyplus.com,fast.wistia.net,help.hulu.com,help.netflix.com,hulu,hulu.com,id.twitch.tv,iq.com,iqiyi,iqiyi.com,jobs.netflix.com,justin.tv,m.twitch.tv,m.youtube.com,music.youtube.com,netflix,netflix.com,player.twitch.tv,player.vimeo.com,ted,ted.com,twitch,twitch.tv,utreon,utreon.com,veoh,veoh.com,viadeo.journaldunet.com,vimeo,vimeo.com,wistia,wistia.com,youku,youku.com,youtube,youtube.com'.split(','),
  );
  const SHOPPING_PATTERN = /^(.*(([^a-df-z]|^)shop|shopping).*)$/;
  const PAID_PATTERN = /^(.*cp.*|ppc|retargeting|paid.*)$/;
  const VIDEO_PATTERN = /^(.*video.*)$/;
  const SOCIAL_HOSTS = [
    'facebook.com',
    'fb.me',
    'instagram.com',
    'tiktok.com',
    'twitter.com',
    'x.com',
    't.co',
    'pinterest.com',
    'linkedin.com',
    'snapchat.com',
    'reddit.com',
    'youtube.com',
    'youtu.be',
    'threads.net',
    'whatsapp.com',
    'wa.me',
    'telegram.org',
    't.me',
    'vk.com',
  ];
  const SOCIAL_QUERY_PARAMS = ['fbclid', 'ttclid', 'twclid', 'tw_adid', 'li_fat_id', 'epik', 'sccid'];
  const SOCIAL_UTM_VALUES = [
    'facebook',
    'fb',
    'instagram',
    'ig',
    'tiktok',
    'twitter',
    'x',
    'pinterest',
    'linkedin',
    'snapchat',
    'reddit',
    'youtube',
    'threads',
    'whatsapp',
    'telegram',
    'vk',
  ];

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // The component still works if sessionStorage is unavailable.
    }
  }

  function hostMatchesSocial(hostname) {
    const normalizedHost = hostname.toLowerCase().replace(/^www\./, '');
    return SOCIAL_HOSTS.some((socialHost) => (
      normalizedHost === socialHost || normalizedHost.endsWith(`.${socialHost}`)
    ));
  }

  function hasSocialReferrer() {
    if (!document.referrer) return false;

    try {
      return hostMatchesSocial(new URL(document.referrer).hostname);
    } catch (error) {
      return false;
    }
  }

  function hasSocialCampaignParameters() {
    const params = new URLSearchParams(window.location.search);
    if (SOCIAL_QUERY_PARAMS.some((param) => params.has(param))) return true;

    const utmMedium = (params.get('utm_medium') || '').toLowerCase();
    const utmSource = (params.get('utm_source') || '').toLowerCase();
    const socialMediums = ['social', 'social-network', 'social-media', 'paid-social', 'paidsocial', 'organic-social'];

    return socialMediums.includes(utmMedium)
      || SOCIAL_UTM_VALUES.some((value) => utmSource === value || utmSource.includes(`${value}_`));
  }

  function isSocialInAppBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('instagram')
      || userAgent.includes('fbav')
      || userAgent.includes('fban')
      || userAgent.includes('musical_ly')
      || userAgent.includes('tiktok')
      || userAgent.includes('telegram');
  }

  function isSocialSession() {
    if (storageGet(SOCIAL_SESSION_KEY) === '1') return true;

    const socialEntry = hasSocialReferrer() || hasSocialCampaignParameters() || isSocialInAppBrowser();
    if (socialEntry) storageSet(SOCIAL_SESSION_KEY, '1');
    return socialEntry;
  }

  function getReferrerHost() {
    if (!document.referrer) return '';

    try {
      return new URL(document.referrer).hostname.replace(/^www\./, '');
    } catch (error) {
      return '';
    }
  }

  function hasOnlyIrrelevantDirectParams(params) {
    for (const [key] of params) {
      if (!IRRELEVANT_DIRECT_PARAMS.has(key)) return false;
    }

    return true;
  }

  function classifyTrafficSource() {
    const params = new URLSearchParams(window.location.search);
    const referrer = getReferrerHost();
    const userAgent = navigator.userAgent.toLowerCase();
    const utmSource = (params.get('utm_source') || '').toLowerCase();
    const utmMedium = (params.get('utm_medium') || '').toLowerCase();
    const utmCampaign = (params.get('utm_campaign') || '').toLowerCase();
    const hasParam = (name) => Boolean((params.get(name) || '').toLowerCase());
    const inFacebookOrInstagramBrowser = userAgent.includes('instagram')
      || userAgent.includes('fbav')
      || userAgent.includes('fban');
    const isShoppingReferrer = SHOPPING_SITES.has(referrer) || SHOPPING_SITES.has(utmSource);
    const isSocialReferrer = APP_SOCIAL_SITES.has(referrer) || APP_SOCIAL_SITES.has(utmSource);
    const isSearchReferrer = SEARCH_SITES.has(referrer) || SEARCH_SITES.has(utmSource);
    const isVideoReferrer = VIDEO_SITES.has(referrer) || VIDEO_SITES.has(utmSource);
    const isDisplay = ['display', 'banner', 'expandable', 'interstitial', 'cpm'].includes(utmMedium);
    const isSocialMedium = [
      'social',
      'social-network',
      'social-media',
      'sm',
      'social network',
      'social media',
    ].includes(utmMedium);
    const isReferralMedium = ['referral', 'app', 'link'].includes(utmMedium);

    if (!referrer && !utmMedium && hasOnlyIrrelevantDirectParams(params)) return 'Direct';
    if (isShoppingReferrer || (PAID_PATTERN.test(utmMedium) && SHOPPING_PATTERN.test(utmCampaign))) {
      return 'Paid Shopping';
    }
    if (
      (isSearchReferrer && PAID_PATTERN.test(utmMedium))
      || hasParam('gclid')
      || hasParam('gad_source')
      || hasParam('wbraid')
      || hasParam('gbraid')
    ) return 'Paid Search';
    if (
      ((isSocialReferrer || inFacebookOrInstagramBrowser) && PAID_PATTERN.test(utmMedium))
      || hasParam('fbclid')
      || hasParam('ttclid')
      || hasParam('twclid')
      || hasParam('tw_adid')
    ) return 'Paid Social';
    if (isVideoReferrer && PAID_PATTERN.test(utmMedium)) return 'Paid Video';
    if (isDisplay) return 'Display';
    if (PAID_PATTERN.test(utmMedium)) return 'Paid Other';
    if (isShoppingReferrer || SHOPPING_PATTERN.test(utmCampaign)) return 'Organic Shopping';
    if (isSocialReferrer || inFacebookOrInstagramBrowser || isSocialMedium) return 'Organic Social';
    if (isVideoReferrer || VIDEO_PATTERN.test(utmMedium)) return 'Organic Video';
    if (isSearchReferrer || utmMedium === 'organic') return 'Organic Search';
    if (isReferralMedium) return 'Referral';
    if (utmMedium === 'affiliate') return 'Affiliate';
    if (utmSource === 'sms' || utmMedium === 'sms' || utmMedium === 'text') return 'SMS';
    if (
      ['email', 'e_mail', 'e-mail', 'e mail'].includes(utmMedium)
      || ['email', 'e_mail', 'e-mail', 'e mail'].includes(utmSource)
      || hasParam('_kx')
    ) return 'Email';

    return 'Unclassified';
  }

  function getEntryTrafficSource() {
    const storedSource = storageGet(TRAFFIC_SOURCE_SESSION_KEY);
    if (storedSource) return storedSource;

    const source = classifyTrafficSource();
    storageSet(TRAFFIC_SOURCE_SESSION_KEY, source);
    return source;
  }

  function isMobileDevice() {
    return /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  }

  function isExcludedPath(pathPrefixes) {
    return pathPrefixes.some((prefix) => window.location.pathname.startsWith(prefix));
  }

  function parseBoolean(value, fallback) {
    if (typeof value === 'undefined') return fallback;
    return value === 'true';
  }

  function parseWhitespaceList(value, fallback) {
    if (typeof value === 'undefined') return fallback;
    return value.split(/[\s,]+/).map((item) => item.trim()).filter(Boolean);
  }

  function getAudienceConfig(element) {
    const eligibleCountries = parseWhitespaceList(element.dataset.countryCodes, DEFAULT_ELIGIBLE_COUNTRIES)
      .map((country) => country.toUpperCase());
    const excludedPathPrefixes = parseWhitespaceList(
      element.dataset.excludedPaths,
      DEFAULT_EXCLUDED_PATH_PREFIXES,
    );

    return {
      mobileOnly: parseBoolean(element.dataset.mobileOnly, true),
      countryTargeting: eligibleCountries.length > 0,
      eligibleCountries: new Set(eligibleCountries),
      trafficTargeting: parseBoolean(element.dataset.trafficTargeting, true),
      blockedTrafficSources: new Set(DEFAULT_BLOCKED_TRAFFIC_SOURCES),
      pathExclusions: excludedPathPrefixes.length > 0,
      excludedPathPrefixes,
    };
  }

  function getCachedCountry() {
    const cachedValue = storageGet(COUNTRY_SESSION_KEY);
    if (!cachedValue) return null;

    try {
      const cached = JSON.parse(cachedValue);
      if (cached.country && cached.expiresAt > Date.now()) return cached.country;
    } catch (error) {
      // Ignore an invalid or expired cache entry.
    }

    return null;
  }

  async function getDetectedCountry() {
    const cachedCountry = getCachedCountry();
    if (cachedCountry) return cachedCountry;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}browsing_context_suggestions.json?country%5Benabled%5D=true`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return null;

      const data = await response.json();
      const country = data.detected_values?.country?.handle?.toUpperCase() || null;
      if (country) {
        storageSet(COUNTRY_SESSION_KEY, JSON.stringify({
          country,
          expiresAt: Date.now() + COUNTRY_CACHE_TTL,
        }));
      }

      return country;
    } catch (error) {
      return null;
    }
  }

  async function isEligibleVisitor(config) {
    if (config.mobileOnly && !isMobileDevice()) return false;
    if (config.pathExclusions && isExcludedPath(config.excludedPathPrefixes)) return false;
    if (config.trafficTargeting) {
      const trafficSource = getEntryTrafficSource();
      if (trafficSource === 'Unclassified') return false;
      if (config.blockedTrafficSources.has(trafficSource)) return false;

      const isUnclassifiedSocialEntry = isSocialSession() && trafficSource === 'Direct';
      if (isUnclassifiedSocialEntry && config.blockedTrafficSources.has('Organic Social')) return false;
    }

    if (config.countryTargeting) {
      const country = await getDetectedCountry();
      if (!config.eligibleCountries.has(country)) return false;
    }

    return true;
  }

  if (!customElements.get('tfc-inner-dialog')) {
    class TfcInnerDialog extends HTMLElement {
      async connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        if (!window.Shopify?.designMode) {
          const isEligible = await isEligibleVisitor(getAudienceConfig(this));
          if (!this.isConnected) return;
          if (!isEligible) {
            this.remove();
            return;
          }
        }

        this.bar = this.querySelector('.tfc-inner-dialog-bar');
        this.panel = this.querySelector('.tfc-inner-dialog-panel');
        this.ticker = this.querySelector('.tfc-inner-dialog-ticker');
        this.slides = Array.from(this.querySelectorAll('[data-inner-dialog-panel]'));
        this.pagination = this.querySelector('.tfc-inner-dialog-pagination');
        this.currentSlide = 0;
        this.currentTickerSlide = 0;
        this.cycleSpeed = Number(this.dataset.cycleSpeed) || 5000;
        this.previouslyFocusedElement = null;

        this.onBarClick = this.handleBarClick.bind(this);
        this.onCloseClick = this.close.bind(this);
        this.onPreviousClick = () => this.showSlide(this.currentSlide - 1);
        this.onNextClick = () => this.showSlide(this.currentSlide + 1);
        this.onKeyDown = this.handleKeyDown.bind(this);
        this.onTickerTransitionEnd = this.handleTickerTransitionEnd.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.stopTicker = this.stopTicker.bind(this);
        this.startTicker = this.startTicker.bind(this);
        this.updateOffset = this.setHeaderOffset.bind(this);
        this.headerElements = this.getHeaderElements();

        this.bar?.addEventListener('click', this.onBarClick);
        this.querySelectorAll('[data-inner-dialog-close]').forEach((element) => {
          element.addEventListener('click', this.onCloseClick);
        });
        this.querySelector('[data-inner-dialog-prev]')?.addEventListener('click', this.onPreviousClick);
        this.querySelector('[data-inner-dialog-next]')?.addEventListener('click', this.onNextClick);
        this.ticker?.addEventListener('transitionend', this.onTickerTransitionEnd);
        this.bar?.addEventListener('mouseenter', this.stopTicker);
        this.bar?.addEventListener('mouseleave', this.startTicker);
        this.bar?.addEventListener('focusin', this.stopTicker);
        this.bar?.addEventListener('focusout', this.startTicker);
        document.addEventListener('keydown', this.onKeyDown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        window.addEventListener('resize', this.updateOffset, { passive: true });
        window.addEventListener('scroll', this.updateOffset, { passive: true });
        window.addEventListener('load', this.updateOffset, { once: true });

        if ('ResizeObserver' in window) {
          this.headerResizeObserver = new ResizeObserver(this.updateOffset);
          this.headerElements.forEach((element) => this.headerResizeObserver.observe(element));
        }

        this.setHeaderOffset();
        this.revealFrame = window.requestAnimationFrame(() => {
          this.setHeaderOffset();
          this.hidden = false;
          this.startTicker();
        });
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.bar?.removeEventListener('click', this.onBarClick);
        this.querySelectorAll('[data-inner-dialog-close]').forEach((element) => {
          element.removeEventListener('click', this.onCloseClick);
        });
        this.querySelector('[data-inner-dialog-prev]')?.removeEventListener('click', this.onPreviousClick);
        this.querySelector('[data-inner-dialog-next]')?.removeEventListener('click', this.onNextClick);
        this.ticker?.removeEventListener('transitionend', this.onTickerTransitionEnd);
        this.bar?.removeEventListener('mouseenter', this.stopTicker);
        this.bar?.removeEventListener('mouseleave', this.startTicker);
        this.bar?.removeEventListener('focusin', this.stopTicker);
        this.bar?.removeEventListener('focusout', this.startTicker);
        document.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('resize', this.updateOffset);
        window.removeEventListener('scroll', this.updateOffset);
        window.removeEventListener('load', this.updateOffset);
        this.headerResizeObserver?.disconnect();
        window.cancelAnimationFrame(this.revealFrame);
        this.stopTicker();
        document.body.classList.remove('tfc-inner-dialog-open');
      }

      getHeaderElements() {
        const header = document.querySelector('.shopify-section--header');
        const headerGroupSections = [];
        const sectionWrapper = this.closest('.shopify-section');
        let sibling = sectionWrapper?.previousElementSibling || this.previousElementSibling;

        while (sibling?.classList.contains('shopify-section')) {
          headerGroupSections.push(sibling);
          sibling = sibling.previousElementSibling;
        }

        return Array.from(new Set([
          ...headerGroupSections,
          header,
          header?.querySelector('store-header'),
          header?.querySelector('.header__wrapper'),
        ].filter(Boolean)));
      }

      setHeaderOffset() {
        const headerBottom = this.headerElements.reduce((bottom, element) => (
          Math.max(bottom, element.getBoundingClientRect().bottom)
        ), 0);
        this.style.setProperty('--inner-dialog-offset', `${Math.ceil(headerBottom)}px`);

        if (this.classList.contains('is-open')) this.setPanelHeight();
      }

      setPanelHeight() {
        if (!this.panel) return;

        const panelHeight = Math.min(this.panel.scrollHeight, window.innerHeight * 0.7, 720);
        this.style.setProperty('--inner-dialog-panel-height', `${Math.ceil(panelHeight)}px`);
      }

      startTicker() {
        this.stopTicker();

        if (this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (this.classList.contains('is-open')) return;
        if (this.bar?.matches(':hover, :focus-within')) return;

        this.tickerInterval = window.setInterval(() => {
          this.currentTickerSlide += 1;
          this.style.setProperty('--inner-dialog-ticker-index', this.currentTickerSlide);
        }, this.cycleSpeed);
      }

      stopTicker() {
        window.clearInterval(this.tickerInterval);
        this.tickerInterval = null;
      }

      handleTickerTransitionEnd(event) {
        if (event.propertyName !== 'transform' || this.currentTickerSlide < this.slides.length) return;

        this.ticker?.classList.add('is-resetting');
        this.currentTickerSlide = 0;
        this.style.setProperty('--inner-dialog-ticker-index', 0);

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => this.ticker?.classList.remove('is-resetting'));
        });
      }

      handleBlockSelect(event) {
        const selectedSlide = event.target.closest?.('[data-inner-dialog-panel]');
        if (!selectedSlide || !this.contains(selectedSlide)) return;

        this.open(Number(selectedSlide.dataset.innerDialogPanel));
      }

      handleBarClick(event) {
        const tickerItem = event.target.closest('[data-inner-dialog-slide]');
        const index = Number(tickerItem?.dataset.innerDialogSlide || 0);
        this.open(Number.isNaN(index) ? 0 : index);
      }

      open(index = 0) {
        this.previouslyFocusedElement = document.activeElement;
        this.stopTicker();
        this.showSlide(index);
        this.setPanelHeight();
        this.classList.add('is-open');
        this.bar?.setAttribute('aria-expanded', 'true');
        this.panel?.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tfc-inner-dialog-open');
        this.querySelector('.tfc-inner-dialog-close')?.focus({ preventScroll: true });
      }

      close() {
        if (!this.classList.contains('is-open')) return;

        this.classList.remove('is-open');
        this.bar?.setAttribute('aria-expanded', 'false');
        this.panel?.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('tfc-inner-dialog-open');
        this.previouslyFocusedElement?.focus?.({ preventScroll: true });
        this.startTicker();
      }

      showSlide(index) {
        const slideCount = this.slides.length;
        if (!slideCount) return;

        this.currentSlide = (index + slideCount) % slideCount;
        this.slides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== this.currentSlide;
        });
        if (this.pagination) this.pagination.textContent = `${this.currentSlide + 1} / ${slideCount}`;
        if (this.classList.contains('is-open')) this.setPanelHeight();
      }

      handleKeyDown(event) {
        if (!this.classList.contains('is-open')) return;

        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.showSlide(this.currentSlide - 1);
        if (event.key === 'ArrowRight') this.showSlide(this.currentSlide + 1);
      }
    }

    customElements.define('tfc-inner-dialog', TfcInnerDialog);
  }
})();
